module.exports = __webpack_public_path__ + "static/media/create-home-ok.963a7e14.svg";